import { GeneralService } from './../services/general.service';
import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';

//import '../../assets/js/jquery.carouFredSel-6.0.4-packed.js';

declare var $: any;
declare var jQuery: any;
declare var revslider_showDoubleJqueryError: any;
declare var Odometer: any;
declare var isEmaili: any;


@Component({
    selector: 'app-common-script',
    templateUrl: './common-script.component.html',
    styleUrls: ['./common-script.component.css']
})
export class CommonScriptComponent implements OnInit {

    constructor(private location:LocationStrategy, private generalService:GeneralService) {
        location.onPopState(()=>{
            //console.log(window.location.href);
            
            if(window.location.href == this.generalService.REDIRECT_URL || window.location.href == this.generalService.BASE_URL || window.location.href == 'http://www.veepal.com/' || window.location.href == 'http://www.veepal.com'){
              window.location.reload();
            }
            
         
          })
     }

    ngOnInit() {

        
    }

    

    onLoad() {


        window.scrollTo(0,0);

        //show captcha into popup
        this.show_captcha_popup();

        // Tracenow product slider
        $('.flexslider').flexslider({
            animation: "fade"
        });

        // Script.js code //
        (function ($) {
            "use strict";
            var $theme = 'light',
                $skin = 'default',
                $layout = 'wide',
                $bodyclass = 'bg1',
                $rtl = '0',
                $loadin = '1',
                $loaderStyle = '',
                $sticky = '1',
                $totop = '1';
            var theme_css = $('#theme_css').attr('href'),
                theme_name = theme_css.substring(theme_css.lastIndexOf("/") + 1, theme_css.length),
                th_nam = theme_name.replace('.css', ''),
                skin_css = $('#skin_css').attr('href'),
                skin_name = skin_css.substring(skin_css.lastIndexOf("/") + 1, skin_css.length),
                sk_nam = skin_name.replace('.css', ''),
                theme_url = theme_css.replace(theme_name, ''),
                skin_url = skin_css.replace(skin_name, '');
            if ($theme == th_nam || th_nam == 'light') {
                $('#theme_css').attr('href', theme_url + $theme + '.css');
            } else {
                $('#theme_css').attr('href', theme_url + th_nam + '.css');
            }
            if ($skin == sk_nam || sk_nam == 'default') {
                $('#skin_css').attr('href', skin_url + $skin + '.css');
            } else {
                $('#skin_css').attr('href', skin_url + sk_nam + '.css');
            }
            if ($layout != 'wide') {
                $('.pageWrapper').addClass('boxed');
                if ($('body').attr('class') == undefined) {
                    $('body').addClass($bodyclass);
                }
            }
            if ($rtl == '1') {
                $('head').append('<link rel="stylesheet" href="assets/css/rtl.css">');
                var $rt = true;
            } else {
                var $rt = false;
            }
            if ($loadin == '1') {
                if ($loaderStyle != '') {
                    if ($loaderStyle == 'circles' || $loaderStyle == 'spin_Square' || $loaderStyle == 'large_dots' || $loaderStyle == 'line_with_Dots') {
                        $('.page-loader').append('<div class="' + $loaderStyle + '"><div class="circlesload"></div></div>');
                    } else {
                        $('.page-loader').append('<div class="cp-spinner ' + $loaderStyle + '"></div>');
                    }
                } else {
                    $('.page-loader').prepend('<div class="cssload-container"><div class="cssload-lt"></div><div class="cssload-rt"></div><div class="cssload-lb"></div><div class="cssload-rb"></div></div>');
                }
                if ($('.page-loader').find('.line_with_Dots').length > 0) {
                    $('.circlesload').append('<i></i><i></i><i></i><i></i>');
                }
            } else {
                $(".page-loader").remove();
            }
            if ($('.pageContent').length) {
                var winH = $(window).height(),
                    headH = parseInt($('.top-head').outerHeight(), 10),
                    footH = parseInt($('#footWrapper').outerHeight(), 10),
                    mtop = winH - 200,
                    H = winH - (headH + footH);
                $('.pageContent').css('min-height', H + "px");
                $('.gmap.fullscreen').css({
                    'height': winH + "px"
                });
                $('.fullscreen-contact').css({
                    'margin-top': mtop + "px"
                });
                if ($('.fixed-footer').length) {
                    $('.pageContent').css('margin-bottom', footH + "px");
                }
                if ($('#footWrapper').hasClass('fixed-footer')) {
                    $('.pageContent').addClass('white-bg');
                }
            }
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $('html').addClass('touch');
            } else {
                $('html').addClass('no-touch');
            }
            $('.touch .fx').addClass('animated');
            var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            if (isSafari) {
                $('html').addClass('safari');
            }
            var mainnav = $('.top-nav > ul');
            mainnav.find('li').not('.mega-menu li').each(function () {
                var submenu = $(this).find('> ul');
                if (submenu.length) {
                    $(this).addClass('hasChildren');
                    var $sub = $(this).find('> ul'),
                        $contain = $('.top-head .container');
                    if ($sub.length && $contain.length) {
                        var $c = $contain.width() + $contain.offset().left;
                        $sub.each(function () {
                            var $lft = $(this).offset().left + $(this).outerWidth() - 60;
                            if ($lft > $c) {
                                $(this).addClass('rit-menu');
                            }
                        });
                    } else {
                        var $ww = $(window).width();
                        $sub.each(function () {
                            var $lt = $(this).offset().left + $(this).outerWidth() - 60;
                            if ($lt > $ww) {
                                $(this).addClass('rit-menu');
                            }
                        });
                    }
                    var delay = 0;
                    $(this).find('> ul > li').each(function () {
                        $(this).css({
                            transitionDelay: delay + 'ms'
                        });
                        delay += 50;
                    });
                }
            });
            if ($('.header-left').length > 0) {
                $('.pageWrapper').addClass('left-s side-wrap');
            }
            if ($('.header-right').length > 0) {
                $('.pageWrapper').addClass('right-s side-wrap');
            }
            if ($('.side-nav').length > 0) {
                var side_nav = $('.side-nav'),
                    side_menu = $('.side-nav > ul'),
                    items = side_menu.find('li');
                side_nav.addClass('dl-menuwrapper');
                side_menu.addClass('dl-menu');
                side_menu.find('ul').addClass('dl-submenu');
                side_nav.dlmenu();
                $('.side-wrap .top-head').mCustomScrollbar({
                    axis: "y",
                    scrollInertia: 200
                });
                items.each(function () {
                    var ul = $(this).find('ul:first');
                    if (ul.length) {
                        $(this).addClass('hasChildren');
                    }
                });
            }
            $(document).delegate('.top-head.header-1 .top-search > a', 'click', function () {
                var sbox = $(this).parent().find('.search-box');
                if (sbox.is(':visible')) {
                    $(this).parent().removeClass('actsrch');
                    $(this).find('> span').removeClass('fa-times');
                    $('.top-nav').delay(500).fadeIn(500);
                    sbox.animate({
                        width: '0px'
                    }, 500, 'easeInSine').hide(500);
                    return false;
                } else {
                    $(this).parent().addClass('actsrch');
                    $(this).find('> span').addClass('fa-times');
                    $('.top-nav').fadeOut(500);
                    sbox.delay(300).animate({
                        width: '400px'
                    }, 500, 'easeInSine').show();
                    return false;
                }
            });
            $(document).delegate('.top-head:not(.header-1) .top-search > a', 'click', function () {
                var sbox = $(this).parent().find('.search-box');
                if (sbox.is(':visible')) {
                    $(this).parent().removeClass('ac-search main-bg');
                    sbox.fadeOut();
                    $(this).find('> span').removeClass('fa-times');
                    return false;
                } else {
                    $(this).parent().addClass('ac-search main-bg');
                    $(this).find('> span').addClass('fa-times');
                    sbox.addClass('main-bg').fadeIn();
                    return false;
                }
            });
            $(document).delegate('.top-cart > a', 'click', function () {
                if ($(this).parent().find('.cart-box').is(':visible')) {
                    $(this).parent().removeClass('selected').find('.cart-box').fadeOut(300);
                    return false;
                } else {
                    $(this).parent().addClass('selected').find('.cart-box').fadeIn(300);
                    return false;
                }
            });
            $(document).on("mouseup", function (e) {
                if ($('.cart-box').is(':visible')) {
                    var targ = $(".cart-box");
                    if (!targ.is(e.target) && targ.has(e.target).length === 0) {
                        $('.cart-box').fadeOut(300);
                        $('.top-cart').removeClass('selected');
                    }
                }
            });
            if ($('.responsive-nav').length) {
                var onp = '';
                if ($('.responsive-nav > nav').hasClass('one-page')) {
                    onp = 'responsive-one';
                }
                $('.pageWrapper').prepend('<div class="newNav dark-bg ' + onp + '"><span class="cls"></span><span class="responsive-menu"></span><span class="cls"></span><i class="clo"></i></div>');
                var responsnav = $('.responsive-nav').find('nav').html();
                $('.responsive-menu').html(responsnav);
                var delay = 0;
                $('.responsive-menu').find('> ul > li').each(function () {
                    $(this).css({
                        transitionDelay: delay + 'ms'
                    });
                    delay += 50;
                });
                if ($('.responsive-one').length) {
                    $('.responsive-one').onePageNav();
                }
                $('.responsive-menu').find('ul li.hasChildren').each(function () {
                    $(this).find(' > a').append('<b class="child-arrow fa fa-angle-right"></b>');
                    $(this).find(' h4').append('<b class="child-arrow fa fa-angle-right"></b>');
                    $(this).find('.child-arrow').on("click", function (e) {
                        e.preventDefault();
                        $(this).toggleClass('rot-lft');
                        $(this).parent().parent().find('> ul').slideToggle();
                        $(this).parent().parent().find('.mega-content').find('ul').slideToggle();
                        $(this).parent().parent('li.hasChildren').toggleClass('active');
                        return false;
                    });
                });
                $(document).delegate('.newNav', 'click', function (event) {
                    $(this).addClass('oppenned');
                    $('.clo').show();
                    event.stopPropagation();
                })
                $(document).delegate('body', 'click', function (event) {
                    $('.newNav').removeClass('oppenned');
                    $('.clo').hide();
                })
                $(document).delegate('.clo', 'click', function (event) {
                    $('.newNav').removeClass('oppenned');
                    $(this).hide();
                    event.stopPropagation();
                });
                $('.side-nav .responsive-menu > ul').mCustomScrollbar({
                    axis: "y",
                    scrollInertia: 200
                });
            }
            var ScrlTop = $(window).scrollTop();
            if ($totop == '0') {
                $('#to-top').css('display', 'none');
            } else {
                if (ScrlTop > 400) {
                    $('#to-top').fadeIn();
                } else {
                    $('#to-top').fadeOut();
                }
            }
            if ($('.slbar').length) {
                var icc = $('.slbar_btn').find('i').data('icon');
                $('.slbar_btn').find('i').addClass(icc);
                $('.slbar_btn').click(function (e) {
                    e.preventDefault();
                    var th = $(this).find('i'),
                        ic = th.data('icon'),
                        ictg = th.data('tgl-icon');
                    if (!$('.slbar').hasClass("middle_left") && !$('.slbar').hasClass("middle_right")) {
                        if ($('.sl_bar_content').is(":hidden")) {
                            $('.slbar').addClass('active');
                            $('.sl_bar_content').slideDown();
                            th.removeAttr('class').addClass(ictg);
                        } else {
                            $('.slbar').removeClass('active');
                            $('.sl_bar_content').slideUp();
                            th.removeAttr('class').addClass(ic);
                        }
                    } else {
                        if ($('.sl_bar_content').is(":hidden")) {
                            $('.sl_bar_content').show(0);
                            if ($('.slbar').is('.middle_right.cont_push')) {
                                $('.pageWrapper').css('transform', 'translate3d(-300px,0,0)');
                            } else if ($('.slbar').is('.middle_left.cont_push')) {
                                $('.pageWrapper').css('transform', 'translate3d(300px,0,0)');
                            }
                            $('body').addClass('slbar-push-body opened-slid').append('<div class="body-overlay"></div>');
                            $('.slbar').addClass('active').css('transform', 'translate3d(0,0,0)');
                            th.removeAttr('class').addClass(ictg);
                        } else {
                            setTimeout(function () {
                                $('.sl_bar_content').hide();
                            }, 500);
                            $('.slbar').removeClass('active').removeAttr('style');
                            $('.pageWrapper').css('transform', 'translate3d(0,0,0)');
                            $('body').removeClass('slbar-push-body opened-slid').find('.body-overlay').remove();
                            th.removeAttr('class').addClass(ic);
                        }
                    }
                    $(document).mouseup(function (e) {
                        var container = $(".slbar");
                        if (!container.is(e.target) && container.has(e.target).length === 0 && $('.sl_bar_content').is(":visible")) {
                            if (container.is('.middle_right') || container.is('.middle_left')) {
                                container.hide();
                                $('body').removeClass('slbar-push-body opened-slid').find('.body-overlay').remove();
                                setTimeout(function () {
                                    $('.sl_bar_content').hide();
                                }, 500);
                                var ic = $('.slbar_btn').find('i').data('icon'),
                                    ictg = $('.slbar_btn').find('i').data('tgl-icon');
                                $('.slbar').removeClass('active').removeAttr('style');
                                $('.slbar_btn').find('i').removeAttr('class').addClass(ic);
                                $('.pageWrapper').css('transform', 'translate3d(0,0,0)');
                            }
                        }
                    });
                });
            }
            $('#to-top,.divider .to-top').on("click", function () {
                $('html, body').animate({
                    scrollTop: '0px'
                }, 800);
                return false;
            });
            $('.rect-angles').each(function () {
                $(this).children().wrapAll('<span><span><span></span></span></span>');
            });
            $('.icon-box-1').each(function () {
                var parH = $(this).parent().outerHeight();
                $(this).css('height', parH);
            });
            $('.heading.main').each(function () {
                $(this).find('.lg-title').after('<b class="head-sep"><u></u></b>');
            });
            $('.menu-tabs').each(function () {
                $(this).find('.nav-tabs a').each(function () {
                    $(this).on('click', function () {
                        var idd = $(this).attr('href').replace('#', '');;
                        $(this).parent().parent().parent().find('.tab-pane').removeClass('in active');
                        $(this).parent().parent().parent().find('#' + idd).addClass('in active');
                    });
                });
            });
            if ($('.top-head:not(.header-1)').length) {
                var logH: number = 0;
                if ($('.header-2').hasClass('boxed')) {
                    logH = $('.top-head:not(.center-logo) .logo').outerHeight() - 35;
                } else {
                    logH = $('.top-head:not(.center-logo) .logo').outerHeight();
                }
                if (logH > 65) {
                    $('.top-nav > ul > li > a > span, .top-nav > ul > li > span > a > span,.top-head .top-search > a,.top-head .top-cart > a').css('line-height', logH + "px");
                }
            }
            if ($('#grid').length) {
                var $grid = $('#grid').isotope({
                    layoutMode: 'fitRows'
                });
                $grid.imagesLoaded(function () {
                    $grid.isotope();
                });
                $('#filters').on('click', 'a.filter', function (e) {
                    e.preventDefault();
                    var filterValue = $(this).attr('data-filter');
                    $grid.isotope({
                        filter: filterValue
                    });
                    var $this = $(this);
                    if ($this.parent().hasClass('selected')) {
                        return false;
                    }
                    var $optionSet = $this.parents('#filters');
                    $optionSet.find('.selected').removeClass('selected');
                    $this.parent().addClass('selected');
                });
            }
            if ($('#masonry').length) {
                var $masonry = $('#masonry').isotope({
                    layoutMode: 'masonry',
                    isFitWidth: true
                });
                $masonry.imagesLoaded(function () {
                    $masonry.isotope();
                });
                $('#filters').on('click', 'a.filter', function (e) {
                    e.preventDefault();
                    var filterValue = $(this).attr('data-filter');
                    $masonry.isotope({
                        filter: filterValue
                    });
                    var $this = $(this);
                    if ($this.parent().hasClass('selected')) {
                        return false;
                    }
                    var $optionSet = $this.parents('#filters');
                    $optionSet.find('.selected').removeClass('selected');
                    $this.parent().addClass('selected');
                });
            }
            $('.social-list a i').each(function () {
                var contt = window.getComputedStyle(this, ':before').content.replace(/\'/g, "").replace(/\"/g, "");
                $(this).attr('data-hover', contt);
            });
            var runSlick = function () {
                if ($('.horizontal-slider').length > 0) {
                    $('.horizontal-slider').each(function () {
                        var slides_n = parseInt($(this).attr('data-slides_count'), 10),
                            sscrol = parseInt($(this).attr('data-scroll_amount'), 10),
                            t_infinite = $(this).attr('data-slider-infinite'),
                            t_arr = $(this).attr('data-slider-arrows'),
                            speed_n = $(this).attr('data-slider-speed'),
                            t_fade = $(this).attr('data-slider-fade'),
                            t_dots = $(this).attr('data-slider-dots'),
                            t_auto = $(this).attr('data-slider-auto'),
                            t_center = $(this).attr('data-center-mode'),
                            fd = false,
                            tinfinite = false,
                            aut = false,
                            arr = true,
                            cen = false,
                            tdots = true,
                            resp_n = 1;
                        if (t_infinite == '1') {
                            tinfinite = true;
                        }
                        if (t_auto == '1') {
                            aut = true;
                        }
                        if (t_fade == '1') {
                            fd = true;
                        }
                        if (t_center == '1') {
                            cen = true;
                            $(this).addClass('center');
                        }
                        if (t_arr == '0') {
                            arr = false;
                        }
                        if (t_dots == '0') {
                            tdots = false;
                        }
                        if (slides_n > 2) {
                            resp_n = 2;
                        }
                        $(this).slick({
                            slidesToShow: slides_n,
                            slidesToScroll: sscrol,
                            dots: tdots,
                            infinite: tinfinite,
                            speed: speed_n,
                            centerMode: cen,
                            fade: fd,
                            autoplay: aut,
                            arrows: arr,
                            responsive: [{
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: resp_n,
                                    slidesToScroll: resp_n
                                }
                            }, {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }]
                        });
                    });
                }
                if ($('.vertical-slider').length > 0) {
                    $('.vertical-slider').each(function () {
                        var vslides_n = parseInt($(this).attr('data-slides_count'), 10),
                            vsscrol = parseInt($(this).attr('data-scroll_amount'), 10),
                            vt_infinite = $(this).attr('data-slider-infinite'),
                            vt_arr = $(this).attr('data-slider-arrows'),
                            vspeed_n = $(this).attr('data-slider-speed'),
                            vt_fade = $(this).attr('data-slider-fade'),
                            vt_dots = $(this).attr('data-slider-dots'),
                            vt_auto = $(this).attr('data-slider-auto'),
                            vfd = false,
                            vtinfinite = false,
                            vaut = false,
                            varr = true,
                            vtdots = true,
                            vresp_n = 1;
                        if (vt_infinite == '1') {
                            vtinfinite = true;
                        }
                        if (vt_auto == '1') {
                            vaut = true;
                        }
                        if (vt_fade == '1') {
                            vfd = true;
                        }
                        if (vt_arr == '0') {
                            varr = false;
                        }
                        if (vt_dots == '0') {
                            vtdots = false;
                        }
                        if (vslides_n > 2) {
                            vresp_n = 2;
                        }
                        $(this).slick({
                            slidesToShow: vslides_n,
                            slidesToScroll: vsscrol,
                            dots: vtdots,
                            infinite: vtinfinite,
                            speed: vspeed_n,
                            fade: vfd,
                            vertical: true,
                            autoplay: vaut,
                            arrows: varr
                        });
                    });
                }
            }
            if ($(".product-zoom").length) {
                $('.product-zoom').slick({
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    customPaging: function (slider, i) {
                        var sl = $(slider.$slides[i]).find('.zoom').attr('href');
                        return '<img src=' + sl + ' />';
                    },
                });
            }
            var fixx = 0,
                sid = 0;
            var st = $('.top-head').attr('data-sticky');
            if ($('.top-head').hasClass('fixed-head')) {
                fixx = 1;
            }
            if ($('.top-head').hasClass('header-left') || $('.top-head').hasClass('header-right')) {
                sid = 1;
            }
            $(window).on("scroll", function () {
                var ScTop = $(this).scrollTop();
                if (($sticky == "1" && sid == 0 && st != "false") || st == "true") {
                    $('.top-head:not(.header-left):not(.header-right)').attr('data-sticky');
                    if (ScTop > 1) {
                        if (!$('.top-head').hasClass('sticky-nav')) {
                            if (($("body").height() - $(window).height()) > 50) {
                                $('.top-head').addClass('sticky-nav');
                            }
                        }
                    } else {
                        if ($('.top-head').hasClass('sticky-nav')) {
                            $('.top-head').removeClass('sticky-nav');
                        }
                    }
                }
                if (fixx == 1) {
                    if (ScTop > 100) {
                        $('.top-head').removeClass('fixed-head');
                    } else {
                        $('.top-head').addClass('fixed-head');
                    }
                }
                if ($totop == '0') {
                    $('#to-top').css('display', 'none');
                } else {
                    if (ScTop > 400) {
                        $('#to-top').fadeIn();
                    } else {
                        $('#to-top').fadeOut();
                    }
                }
            });
            $(window).on("resize", function () {
                resIcs();
                fullschit();
            });
            $('.horizontal-slider').each(function () {
                $(this).find('.slick-dots,.slick-prev,.slick-next').wrapAll('<div class="slider_controls" />');
            });
            $('.modal[role="dialog"]').on('show.bs.modal', function (event) {
                $('.pageWrapper,#contentWrapper,.section,[class*="-padding"] > .container').addClass('pos-static');
            });
            $('.modal[role="dialog"]').on('hide.bs.modal', function (event) {
                $('.pageWrapper,#contentWrapper,.section,[class*="-padding"] > .container').removeClass('pos-static');
            });
            var trigger = $("body").find('[data-toggle="modal"]');
            trigger.on("click", function () {
                var theModal = $(this).data("target"),
                    videoSRC = $(this).attr("data-theVideo"),
                    videoSRCauto = videoSRC + "?autoplay=1";
                $(theModal + ' iframe').attr('src', videoSRCauto);
                $(theModal + ' button.close').on("click", function () {
                    $(theModal + ' iframe').attr('src', videoSRC);
                });
                $('.modal-media').on("click", function () {
                    $(theModal + ' iframe').attr('src', videoSRC);
                    return false;
                });
            });
            var mod = $('.modal [data-toggle="modal"]');
            mod.on('click', function () {
                $('body').css({
                    'padding': '0px'
                });
            });
            $('.alert').each(function () {
                var closebtn = $(this).attr('data-close');
                if (typeof closebtn !== typeof undefined && closebtn !== 'false') {
                    $(this).prepend('<a class="close fa fa-times" href="#"></a>');
                    $(this).find('a.close').on("click", function (e) {
                        e.preventDefault();
                        $(this).parent().addClass('animated fadeOutDown').delay(500).queue(function (n) {
                            $(this).remove();
                        });
                        return false;
                    });
                }
            });
            resIcs();
            $('.team-box.box-3').each(function () {
                var thisT = $(this).find('.tm-img').attr('src');
                $(this).find('.top-team,.bottom-team').css('background-image', 'url("' + thisT + '")');
            });
            $('.odometer').each(function () {
                var the = $(this),
                    tm = the.attr('data-timer'),
                    af = the.attr('data-after'),
                    vl = the.attr('data-value'),
                    them = 'default',
                    t = $(this).attr('data-theme');
                if (typeof t !== typeof undefined && t !== 'false') {
                    them = t;
                }
                var o = new Odometer({
                    el: this,
                    theme: them
                });
                o.render();
                $(this).appear(function () {
                    setInterval(function () {
                        o.update(vl);
                    }, tm);
                    if (typeof af !== typeof undefined && af !== 'false') {
                        the.after('<b class="aft-odo">' + af + '</b>');
                    }
                }, {
                        accY: -100
                    });
            });
            $('[data-toggle="tooltip"]').tooltip();
            $('[data-toggle="popover"]').popover({
                html: true
            });
            $('[data-toggle="dropdown"]').dropdown();
            $(":checkbox").labelauty();
            $('.bo-chart').each(function () {
                var boosize = $(this).attr('data-size');
                $(this).find('span.wrapper').css({
                    'width': boosize + 'px',
                    'height': boosize + 'px'
                });
                $(this).appear(function () {
                    $(this).easyPieChart({
                        easing: 'easeout',
                        onStep: function (from, to, percent) {
                            $(this.el).find('.percent').text(Math.round(percent));
                        }
                    });
                }, {
                        accY: -100
                    });
            });
            $('.toggle').each(function () {
                var ths = $(this),
                    thsID = ths.attr('id'),
                    acc_bod = ths.find('.acc-body');
                acc_bod.each(function (i) {
                    $(this).attr('id', thsID + '_' + (i + 1));
                    $(this).parent().find('h5.acc-head a').attr({
                        'data-toggle': 'collapse',
                        'data-parent': thsID,
                        'href': '#' + $(this).attr('id')
                    });
                });
            });
            $('.list-btn').on("click", function () {
                $('.grid-list').addClass('list');
                $('.grid-btn').removeClass('selected');
                $(this).addClass('selected');
                return false;
            });
            $('.grid-btn').on("click", function () {
                $('.grid-list').removeClass('list');
                $('.list-btn').removeClass('selected');
                $(this).addClass('selected');
                return false;
            });
            var num = $('#items-num').val();
            $('.add-items i.fa-plus').on("click", function (e) {
                e.preventDefault();
                num++;
                $('#items-num').attr('value', num);
                return false;
            });
            $('.add-items i.fa-minus').on("click", function (e) {
                e.preventDefault();
                if (num > 1) {
                    num--;
                    $('#items-num').attr('value', num);
                }
                return false;
            });
            $('.ajax-popup').magnificPopup({
                type: 'ajax',
                preloader: 'true',
                mainClass: '.mpf',
                closeOnContentClick: false,
                callbacks: {
                    ajaxContentAdded: function () {
                        this.content.addClass('newEff');
                        this.content.find('.pro-img-slick').slick({
                            dots: false,
                            arrows: true,
                        });
                        var num = $('#items-num').val();
                        $('.add-items i.fa-plus').on("click", function (e) {
                            e.preventDefault();
                            num++;
                            $('#items-num').attr('value', num);
                        });
                        $('.add-items i.fa-minus').on("click", function (e) {
                            e.preventDefault();
                            if (num > 1) {
                                num--;
                                $('#items-num').attr('value', num);
                            }
                            return false;
                        });
                    }
                }
            });
            $(window).bind("load", function () {
                $('.no-touch .fx').appear(function () {
                    var anim = $(this).attr('data-animate'),
                        del = $(this).attr('data-animation-delay');
                    $(this).addClass('animated ' + anim).css({
                        animationDelay: del + 'ms'
                    });
                }, {
                        accY: -100
                    });
                runSlick();
                fullschit();
                videoBGS();
                if ($('#masonry').length) {
                    var $masonry = $('#masonry').isotope({
                        layoutMode: 'masonry',
                        isFitWidth: true
                    });
                    $masonry.imagesLoaded(function () {
                        $masonry.isotope();
                    });
                    $('#filters').on('click', 'a.filter', function (e) {
                        e.preventDefault();
                        var filterValue = $(this).attr('data-filter');
                        $masonry.isotope({
                            filter: filterValue
                        });
                        var $this = $(this);
                        if ($this.parent().hasClass('active')) {
                            return false;
                        }
                        var $optionSet = $this.parents('#filters');
                        $optionSet.find('.active').removeClass('active');
                        $this.parent().addClass('active');
                    });
                }
                if ($('.blog-masonry').length) {
                    var $masonry = $('.blog-masonry').isotope({
                        layoutMode: 'masonry',
                        isFitWidth: true
                    });
                    $masonry.imagesLoaded(function () {
                        $masonry.isotope();
                    });
                }
                if ($('.blog-grid').length) {
                    var $grid = $('.blog-grid').isotope({
                        layoutMode: 'fitRows'
                    });
                    $grid.imagesLoaded(function () {
                        $grid.isotope();
                    });
                }
                $('.progress-bar').each(function () {
                    $(this).appear(function () {
                        var num = $(this).attr('aria-valuenow');
                        $(this).find('> span').animate({
                            opacity: '1'
                        }, 0);
                        $(this).find('> i').animate({
                            opacity: '1'
                        }, 0)
                        $(this).css('width', num + '%').animate({
                            left: '0%',
                            opacity: '1'
                        }, num * 20);
                        if (num <= 40) {
                            $(this).find('> span').addClass('sm-progress');
                        }
                    }, {
                            accY: -100
                        });
                });
                $.stellar({
                    horizontalScrolling: false,
                    verticalScrolling: true,
                    responsive: true,
                    parallaxElements: true,
                    verticalOffset: -4,
                    hideDistantElements: false
                });
                if ($('.parallax').length > 0) {
                    $('.parallax').each(function () {
                        var pover = $(this).attr('data-overlay');
                        if (pover != undefined) {
                            $(this).prepend('<div class="parallax-overlay" style="background-color:' + pover + '"></div>');
                        }
                    });
                }
                $('a.zoom').magnificPopup({
                    type: 'image',
                    gallery: {
                        enabled: true
                    }
                });
                $('.zoom-media').magnificPopup({
                    type: 'inline'
                });
                if ($('.camera-slider').length) {
                    $('.camera-slider').each(function () {
                        var thscam = $(this),
                            pg = $(this).attr('data-hide-pagination'),
                            th = $(this).attr('data-hide-thumbnails'),
                            hi = $(this).attr('data-height'),
                            pl = $(this).attr('data-hide-play-pause'),
                            nv = $(this).attr('data-hide-navigation'),
                            fxx = $(this).attr('data-fx'),
                            pgn = true,
                            hit = '600px',
                            plp = true,
                            fxxx = 'scrollTop',
                            nvg = true,
                            thm = true;
                        if (typeof pg !== typeof undefined) {
                            pgn = false;
                        }
                        if (typeof th !== typeof undefined) {
                            thm = false;
                        }
                        if (typeof hi !== typeof undefined && hi !== 'false') {
                            hit = $(this).attr('data-height');
                        }
                        if (typeof pl !== typeof undefined) {
                            plp = false;
                        }
                        if (typeof nv !== typeof undefined) {
                            nvg = false;
                        }
                        if (typeof fxx !== typeof undefined && fxx !== 'false') {
                            fxxx = $(this).attr('data-fx');
                        }
                        thscam.camera({
                            height: hit,
                            loader: 'none',
                            pagination: pgn,
                            thumbnails: thm,
                            fx: fxxx,
                            navigation: nvg,
                            playPause: plp
                        });
                    });
                }
                $(".just-gallery").each(function () {
                    var thsT = $(this),
                        rh = $(this).attr('data-row-height'),
                        mr = $(this).attr('data-margins'),
                        mrr = 1,
                        rhh = 120;
                    if (typeof rh !== typeof undefined && rh !== 'false') {
                        rhh = $(this).attr('data-row-height');
                    }
                    if (typeof mr !== typeof undefined && mr !== 'false') {
                        mrr = $(this).attr('data-margins');
                    }
                    thsT.justifiedGallery({
                        rowHeight: rhh,
                        margins: mrr
                    });
                });
                $('.anim-imgs.just-gallery').each(function () {
                    var delay = 0;
                    var bxs = $(this).find('a img');
                    bxs.each(function () {
                        $(this).appear(function () {
                            $(this).css({
                                transform: 'scale(1)',
                                transitionDelay: delay + 'ms',
                                opacity: 1
                            });
                            delay += 180;
                        }, {
                                accY: -150
                            });
                    });
                });
                if ($('.flickr-widget').length > 0) {
                    $('.flickr-widget').each(function () {
                        var thisLmt = $(this).attr('data-limit'),
                            thisFlick = $(this).attr('data-id');
                        $(this).find(' > ul').jflickrfeed({
                            limit: thisLmt,
                            qstrings: {
                                id: thisFlick
                            },
                            itemTemplate: '<li><a href="{{image_b}}" class="zoom"><img src="{{image_s}}" alt="{{title}}" /><span class="img-overlay"></span></a></li>',
                        }, function (data) {
                            $('.zoom').magnificPopup({
                                type: 'image',
                                gallery: {
                                    enabled: true
                                }
                            });
                        });
                    });
                }
                if ($('#flickrFeed3').length > 0) {
                    $('#flickrFeed3').jflickrfeed({
                        limit: 8,
                        qstrings: {
                            id: '45409431@N00'
                        },
                        itemTemplate: '<li><a href="{{image_b}}" class="zoom"><img src="{{image_s}}" alt="{{title}}" /><span class="img-overlay"></span></a></li>'
                    });
                }
                if ($('.tweet').length) {
                    ! function (d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0],
                            p = /^http:/.test(typeof d.location) ? 'http' : 'https';
                        if (!d.getElementById(id)) {
                            js = d.createElement(s);
                            js.id = id;
                            js.async = true;
                            js.src = p + "://platform.twitter.com/widgets.js";
                            fjs.parentNode.insertBefore(js, fjs);
                        }
                    }(document, "script", "twitter-wjs");
                    $('.tweet').prepend('<div class="loading-container"><img src="assets/images/ajax-loader.gif" alt="tweet loader" /></div>');
                    setTimeout(function () {
                        $(".widget_it_widget_tweets").each(function () {
                            var _html = $(this).find('iframe').contents().find("body").html();
                            $(this).find('.tweet').append(_html);
                            $(this).find('.tweet').find('.timeline-LoadMore,iframe,.timeline-Header,.new-tweets-bar,.timeline-Footer,.timeline-Tweet-brand,.u-url.permalink.customisable-highlight,.retweet-credit,.inline-media,.footer.customisable-border,.timeline-Tweet-actions,.timeline-Tweet-metadata').remove();
                            $('.loading-container').hide();
                            $(".footer-middle .timeline .h-feed .u-url.profile span").addClass('main-color');
                            $(this).find(".timeline-TweetList").addClass('vertical-slider show-arrows');
                            $(this).find(".timeline-TweetList").slick({
                                dots: false,
                                infinite: true,
                                arrows: true,
                                speed: 300,
                                slide: 'li',
                                autoplay: true,
                                slidesToShow: 2,
                                touchMove: true,
                                vertical: true,
                                slidesToScroll: 2
                            });
                        });
                    }, 1500);
                }
                if ($loadin == '1') {
                    $(".page-loader").fadeOut();
                    $(".loader-in").fadeOut("slow");
                }
            });

            function resIcs() {
                $('.icon-box-2').each(function () {
                    var ths = $(this),
                        wdt = parseInt(ths.width(), 10) / 2,
                        nm = ths.find('.box-number');
                    nm.css('border-left-width', wdt + 'px').css('border-right-width', wdt + 'px');
                });
            }

            function fullschit() {
                var wH = $(window).height();
                $('.fullscreen-box').css('min-height', wH + "px");
                $('.fullscreen-content').each(function () {
                    var conW = parseInt($(this).outerWidth(), 10) / 2,
                        conH = parseInt($(this).outerHeight(), 10) / 2;
                    $(this).css({
                        marginTop: -conH + 'px',
                        marginLeft: -conW + 'px'
                    })
                });
            }

            function videoBGS() {
                var vid = $('.video-wrap:has(video)');
                if (vid.length > 0) {
                    vid.each(function () {
                        var el = $(this).find('video'),
                            elW = $(this).outerWidth(),
                            elH = $(this).outerHeight(),
                            vidW = el.outerWidth(),
                            vidH = el.outerHeight();
                        if (vidH < elH) {
                            var rat = vidW / vidH,
                                newW = elH * rat,
                                pos = (newW - elW) / 2;
                            el.css({
                                'width': newW + 'px',
                                'height': elH + 'px',
                                'left': -pos + 'px'
                            });
                        } else {
                            var elPos = (vidH - elH) / 2;
                            el.css({
                                'width': vidW + 'px',
                                'height': vidH + 'px',
                                'top': -elPos + 'px'
                            });
                        }
                    });
                }
            }
        })(jQuery);

        // Script.js code //


        //Popup Contact form validation 
        // $("#inq_button").click(function (e) {
        //     var i = $(".ifname").val(),
        //         r = $(".ilname").val(),
        //         s = $(".iemail").val(),
        //         a = $(".iphone").val(),
        //         l = $(".iskype").val(),
        //         m = $(".icontry option:selected").val(),
        //         t = $("textarea.imessage").val(),
        //         n = !0;
        //     if ("" == i) $(".iifname").html("This field is required"), $(".ifname").addClass("error"), n = !1;
        //     else {
        //         var o = /^[a-zA-Z ]*$/;
        //         o.test(i) ? ($(".iifname").html(""), $(".ifname").removeClass("error")) : ($(".iifname").html("Please Enter Only Alphabate"), $(".ifname").addClass("error"), n = !1)
        //     }
        //     if ("" == r) $(".iilname").html("This field is required"), $(".ilname").addClass("error"), n = !1;
        //     else {
        //         var o = /^[a-zA-Z ]*$/;
        //         o.test(r) ? ($(".iilname").html(""), $(".ilname").removeClass("error")) : ($(".iilname").html("Please Enter Only Alphabate"), $(".ilname").addClass("error"), n = !1)
        //     }
        //     if ("" == s ? ($(".iiemail").html("This field is required"), $(".iemail").addClass("error"), n = !1) : isEmaili(s) ? ($(".iiemail").html(""), $(".iemail").removeClass("error")) : ($(".iiemail").html("Please enter valid email"), $(".iemail").addClass("error"), n = !1), "" == a) $(".iiphone").html("This field is required"), $(".iphone").addClass("error"), n = !1;
        //     else {
        //         var o = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]*$/im;
        //         a.length < 6 ? ($(".iiphone").html("Please enter minimum 6 Digits"), $(".iphone").addClass("error"), n = !1) : o.test(a) ? ($(".iiphone").html(""), $(".iphone").removeClass("error")) : ($(".iiphone").html("Please enter only numbers"), $(".iphone").addClass("error"), n = !1)
        //     }
        //     "" == l ? ($(".iiskype").html("This field is required"), $(".iskype").addClass("error"), n = !1) : ($(".iiskype").html(""), $(".iskype").removeClass("error")), "Country" == m ? ($(".iicontry").html("This field is required"), $(".icontry").addClass("error"), n = !1) : ($(".iicontry").html(""), $(".icontry").removeClass("error")), "" == t ? ($(".iimessage").html("This field is required"), $(".imessage").addClass("error"), n = !1) : t.length < 20 ? ($(".iimessage").html("Please enter minimum 20 character"), $(".imessage").addClass("error"), n = !1) : ($(".iimessage").html(""), $(".imessage").removeClass("error")), n && $("#inquiry-form").submit()
        // });

        var tpj = jQuery, revapi4; tpj(window).load(function () { void 0 == tpj("#rev_slider_4_1").revolution ? revslider_showDoubleJqueryError("#rev_slider_4_1") : revapi4 = tpj("#rev_slider_4_1").show().revolution({ sliderType: "standard", jsFileLocation: "assets/revolution/js/", sliderLayout: "fullscreen", dottedOverlay: "none", delay: 9e3, navigation: { keyboardNavigation: "on", keyboard_direction: "horizontal", mouseScrollNavigation: "off", onHoverStop: "off", touch: { touchenabled: "on", swipe_threshold: 75, swipe_min_touches: 1, swipe_direction: "horizontal", drag_block_vertical: !1 }, arrows: { style: "gyges", enable: !0, hide_onmobile: !1, hide_onleave: !1, tmp: "", left: { h_align: "left", v_align: "center", h_offset: 10, v_offset: 0 }, right: { h_align: "right", v_align: "center", h_offset: 10, v_offset: 0 } }, bullets: { enable: !1, hide_onmobile: !1, style: "gyges", hide_onleave: !1, direction: "horizontal", h_align: "center", v_align: "top", h_offset: 0, v_offset: 20, space: 5, tmp: "" } }, parallax: { type: "mouse", origo: "slidercenter", speed: 2e3, levels: [2, 3, 4, 5, 6, 7, 12, 16, 10, 50] }, responsiveLevels: [1240, 1024, 778, 480], gridwidth: [1240, 1024, 778, 480], gridheight: [868, 768, 960, 720], lazyType: "none", shadow: 0, spinner: "off", stopLoop: "on", stopAfterLoops: 0, stopAtSlide: 0, shuffle: "off", autoHeight: "off", fullScreenAlignForce: "off", fullScreenOffsetContainer: "", fullScreenOffset: "", disableProgressBar: "on", hideThumbsOnMobile: "off", hideSliderAtLimit: 0, hideCaptionAtLimit: 0, hideAllCaptionAtLilmit: 0, debugMode: !1, fallbacks: { simplifyAll: "off", nextSlideOnWindowFocus: "off", disableFocusListener: !1 } }) });


        // var CaptchaCallback = function () { $("#RecaptchaField1").length && grecaptcha.render("RecaptchaField1", { sitekey: "6Lc6pDUUAAAAABR_gK7ukk-wlsnOKgB2O4C4jF02" }), $("#RecaptchaField2").length && grecaptcha.render("RecaptchaField2", { sitekey: "6Lc6pDUUAAAAABR_gK7ukk-wlsnOKgB2O4C4jF02" }) };
        //         var j = 1;
        //         $(".inq-button").click(function () { $(".red").html(""), $(".green").html(""), $("#inquiry-form")[0].reset(), setTimeout(function () { var e = window.location.pathname, t = "contact-us"; if (-1 !== e.indexOf(t) && hide_contact_captcha(), j) { $("#RecaptchaField2").empty(), removejscssfile("api.js", "js"); var a = document.createElement("script"); a.src = "https://www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit", a.type = "text/javascript", document.body.parentNode.appendChild(a) } else { $("#RecaptchaField2").empty(), removejscssfile("api.js", "js"); var a = document.createElement("script"); a.src = "https://www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit", a.type = "text/javascript", document.body.parentNode.appendChild(a) } j = 0 }, 100) });
        //         $(".close").click(function () { show_contact_captcha() });
        $(function () { var e = $("#carousel"), i = $(window); e.carouFredSel({ align: !1, items: 10, scroll: { items: 1, duration: 2e3, timeoutDuration: 0, easing: "linear", pauseOnHover: "immediate" } }), i.bind("resize.example", function () { var r = i.width(); 990 > r && (r = 990), e.width(3 * r), e.parent().width(r) }).trigger("resize.example") });
        // $(function(){var e=$("#carousel"),i=$(window);e.carouFredSel({align:!1,items:10,scroll:{items:1,duration:2e3,timeoutDuration:0,easing:"linear",pauseOnHover:"immediate"}}),i.bind("resize.example",function(){var r=i.width();990>r&&(r=990),e.width(3*r),e.parent().width(r)}).trigger("resize.example")});
    }

    show_captcha_popup() {
        $(".inq-button").click(function () {
            
            $(".red").html(""), $(".green").html(""), $("#inquiry-form")[0].reset(), setTimeout(function () {
                //$('#recap1').html('');
                var doc = <HTMLDivElement>document.getElementById('inquiry-form');
                var script = document.createElement('script');
                script.innerHTML = '';
                script.src = 'https://www.google.com/recaptcha/api.js';
                script.async = true;
                script.defer = true;
                doc.appendChild(script);
                $('#recap2').html('<div  class="g-recaptcha" data-sitekey="6LcsxDQUAAAAADNrJh4MO1Pr3LiXpT6m9_tFDPu9"></div><div style="display:none;" class="recapError red_cl">Recaptcha is required</div>');
            }, 100)
        });

        //$(".close").click(function () { alert('hi'); });
    }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/common-script/common-script.component.ts